class Webcitz {
    constructor() {
        this.sessionKey = 'vmr_popup_session'
        this.sessionValue = false
        this.popupEl = $('#globalPopupMessage')
        this.popupCloseBtn = $('#globalPopupClose')
        this.popupOverlay = $('#globalPopupOverlay')

        this.popupInit()
    }
    popupInit() {
        let $this = this
        let closeBtn = $this.popupCloseBtn
        let overlay = $this.popupOverlay

        closeBtn.on('click', $this.closePopup)
        overlay.on('click', $this.closePopup)

        let data = sessionStorage.getItem($this.sessionKey)
        if(!data) {
            $this.showPopup()
        }
    }

    showPopup() {
        let el = $('#globalPopupMessage')
        el.show()
    }

    closePopup() {
        let el = $('#globalPopupMessage')
        let key = 'vmr_popup_session'
        el.hide()
        sessionStorage.setItem(key, true);
    }
}


window.webcitz = new Webcitz